// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.hero-scene-3d {
  --tilt-x: 0deg;
  --tilt-y: 0deg;
  --shift-x: 0px;
  --shift-y: 0px;
  position: absolute;
  inset: 0;
  overflow: hidden;
  pointer-events: none;
  z-index: 0;
  perspective: 1200px;
}

.hero-scene-sky {
  position: absolute;
  inset: 0;
  background:
    radial-gradient(ellipse 70% 55% at 75% 20%, rgba(212, 175, 55, 0.22), transparent 60%),
    radial-gradient(ellipse 55% 50% at 15% 75%, rgba(13, 148, 136, 0.18), transparent 55%),
    linear-gradient(160deg, rgba(10, 37, 64, 0.15) 0%, rgba(37, 99, 235, 0.08) 55%, transparent 100%);
}

.hero-scene-horizon {
  position: absolute;
  left: -10%;
  right: -10%;
  bottom: 8%;
  height: 42%;
  background:
    linear-gradient(180deg, transparent 0%, rgba(255, 255, 255, 0.06) 35%, rgba(10, 37, 64, 0.35) 100%);
  transform: rotateX(62deg) translateZ(-80px);
  transform-origin: center bottom;
  border-top: 1px solid rgba(255, 255, 255, 0.12);
}

.hero-scene-stage {
  position: absolute;
  inset: 0;
  display: grid;
  place-items: center;
  transform-style: preserve-3d;
  transform:
    rotateX(var(--tilt-x))
    rotateY(var(--tilt-y))
    translate3d(var(--shift-x), var(--shift-y), 0);
  transition: transform 0.35s ease-out;
}

.hero-scene-orb {
  position: absolute;
  border-radius: 50%;
  filter: blur(2px);
  opacity: 0.55;
  animation: heroOrbFloat 9s ease-in-out infinite;
}

.hero-scene-orb-a {
  width: 180px;
  height: 180px;
  top: 14%;
  right: 12%;
  background: radial-gradient(circle at 35% 35%, rgba(212, 175, 55, 0.45), transparent 70%);
}

.hero-scene-orb-b {
  width: 140px;
  height: 140px;
  bottom: 18%;
  left: 10%;
  background: radial-gradient(circle at 40% 40%, rgba(49, 130, 206, 0.4), transparent 70%);
  animation-delay: -3s;
}

.hero-ship {
  position: absolute;
  width: min(42vw, 340px);
  height: 78px;
  bottom: 22%;
  left: 8%;
  transform: translateZ(-40px) rotateY(-18deg) rotateX(8deg);
  transform-style: preserve-3d;
  animation: heroShipBob 5.5s ease-in-out infinite;
  opacity: 0.9;
}

.hero-ship-hull {
  position: absolute;
  inset: 28px 0 0;
  background: linear-gradient(180deg, #dbe7f5 0%, #8fa7c4 45%, #3d5a80 100%);
  clip-path: polygon(4% 0, 96% 0, 100% 100%, 0 100%);
  border-radius: 0 0 40% 40% / 0 0 60% 60%;
  box-shadow: 0 18px 30px rgba(0, 0, 0, 0.28);
}

.hero-ship-bridge {
  position: absolute;
  width: 22%;
  height: 34px;
  right: 12%;
  bottom: 48px;
  background: linear-gradient(180deg, #f8fafc, #94a3b8);
  border-radius: 4px 4px 0 0;
  box-shadow: inset 0 -8px 0 rgba(10, 37, 64, 0.2);
}

.hero-ship-stack {
  position: absolute;
  width: 8%;
  height: 28px;
  right: 18%;
  bottom: 78px;
  background: linear-gradient(180deg, #d4af37, #8b6914);
  border-radius: 3px 3px 0 0;
}

.hero-ship-wake {
  position: absolute;
  left: -18%;
  bottom: -6px;
  width: 40%;
  height: 16px;
  background: radial-gradient(ellipse at center, rgba(255, 255, 255, 0.45), transparent 70%);
  filter: blur(2px);
  animation: heroWake 2.8s ease-in-out infinite;
}

.hero-container-stack {
  position: absolute;
  width: min(46vw, 360px);
  height: 220px;
  right: 8%;
  top: 18%;
  transform-style: preserve-3d;
  transform: rotateX(12deg) rotateY(-28deg) translateZ(40px);
  animation: heroStackFloat 6.5s ease-in-out infinite;
}

.hero-box {
  position: absolute;
  width: 170px;
  height: 98px;
  transform-style: preserve-3d;
  left: 50%;
  margin-left: -85px;
}

.hero-box span {
  position: absolute;
  inset: 0;
  border: 1px solid rgba(255, 255, 255, 0.2);
  box-shadow: inset 0 0 0 1px rgba(0, 0, 0, 0.08);
}

.hero-box span:nth-child(1) {
  background:
    repeating-linear-gradient(
      90deg,
      rgba(255, 255, 255, 0.08) 0 8px,
      transparent 8px 18px
    ),
    linear-gradient(145deg, #d4af37 0%, #b8945f 55%, #8b6914 100%);
  transform: translateZ(42px);
}

.hero-box span:nth-child(2) {
  background: linear-gradient(180deg, #2c5282, #1a365d);
  transform: rotateY(90deg) translateZ(42px);
  width: 84px;
  left: auto;
  right: -42px;
}

.hero-box span:nth-child(3) {
  background: linear-gradient(90deg, #1e3a5f, #0f2744);
  transform: rotateX(-90deg) translateZ(42px);
  height: 84px;
  top: auto;
  bottom: -42px;
}

.hero-box em {
  position: absolute;
  inset: 0;
  display: grid;
  place-items: center;
  transform: translateZ(43px);
  font-style: normal;
  font-weight: 800;
  letter-spacing: 0.14em;
  font-size: 0.78rem;
  color: rgba(10, 37, 64, 0.85);
  text-shadow: 0 1px 0 rgba(255, 255, 255, 0.25);
  pointer-events: none;
}

.hero-box-back {
  top: 8px;
  transform: translate3d(-36px, 0, -70px) scale(0.92);
  opacity: 0.72;
}

.hero-box-back span:nth-child(1) {
  background:
    repeating-linear-gradient(90deg, rgba(255, 255, 255, 0.07) 0 8px, transparent 8px 18px),
    linear-gradient(145deg, #3182ce, #1a365d);
}

.hero-box-mid {
  top: 46px;
  transform: translate3d(18px, 0, -20px) scale(0.96);
  opacity: 0.88;
}

.hero-box-mid span:nth-child(1) {
  background:
    repeating-linear-gradient(90deg, rgba(255, 255, 255, 0.08) 0 8px, transparent 8px 18px),
    linear-gradient(145deg, #0d9488, #115e59);
}

.hero-box-front {
  top: 88px;
  transform: translate3d(0, 0, 30px);
  animation: heroFrontPulse 4.8s ease-in-out infinite;
}

.hero-crane {
  position: absolute;
  width: 160px;
  height: 220px;
  right: 42%;
  top: 10%;
  transform: translateZ(-10px) rotateY(12deg);
  opacity: 0.75;
  animation: heroCraneSway 7s ease-in-out infinite;
}

.hero-crane-mast {
  position: absolute;
  left: 50%;
  bottom: 0;
  width: 10px;
  height: 100%;
  margin-left: -5px;
  background: linear-gradient(180deg, #f8fafc, #64748b);
  border-radius: 4px;
}

.hero-crane-arm {
  position: absolute;
  top: 18%;
  left: 18%;
  width: 120px;
  height: 8px;
  background: linear-gradient(90deg, #d4af37, #f1e4b3);
  border-radius: 4px;
  transform-origin: left center;
  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.25);
}

.hero-crane-cable {
  position: absolute;
  top: 22%;
  left: 78%;
  width: 2px;
  height: 70px;
  background: rgba(255, 255, 255, 0.55);
  animation: heroCable 3.6s ease-in-out infinite;
}

.hero-crane-hook {
  position: absolute;
  top: calc(22% + 70px);
  left: calc(78% - 8px);
  width: 18px;
  height: 14px;
  border: 2px solid rgba(212, 175, 55, 0.9);
  border-top: none;
  border-radius: 0 0 10px 10px;
  animation: heroCable 3.6s ease-in-out infinite;
}

@keyframes heroOrbFloat {
  0%,
  100% {
    transform: translate3d(0, 0, 0);
  }
  50% {
    transform: translate3d(12px, -18px, 20px);
  }
}

@keyframes heroShipBob {
  0%,
  100% {
    transform: translateZ(-40px) rotateY(-18deg) rotateX(8deg) translateY(0);
  }
  50% {
    transform: translateZ(-40px) rotateY(-18deg) rotateX(8deg) translateY(-10px);
  }
}

@keyframes heroWake {
  0%,
  100% {
    opacity: 0.35;
    transform: scaleX(1);
  }
  50% {
    opacity: 0.7;
    transform: scaleX(1.15);
  }
}

@keyframes heroStackFloat {
  0%,
  100% {
    transform: rotateX(12deg) rotateY(-28deg) translateZ(40px) translateY(0);
  }
  50% {
    transform: rotateX(12deg) rotateY(-28deg) translateZ(40px) translateY(-14px);
  }
}

@keyframes heroFrontPulse {
  0%,
  100% {
    filter: drop-shadow(0 18px 24px rgba(0, 0, 0, 0.28));
  }
  50% {
    filter: drop-shadow(0 26px 34px rgba(212, 175, 55, 0.28));
  }
}

@keyframes heroCraneSway {
  0%,
  100% {
    transform: translateZ(-10px) rotateY(12deg) rotate(-1.5deg);
  }
  50% {
    transform: translateZ(-10px) rotateY(12deg) rotate(1.5deg);
  }
}

@keyframes heroCable {
  0%,
  100% {
    transform: translateY(0);
  }
  50% {
    transform: translateY(12px);
  }
}

@media (max-width: 900px) {
  .hero-ship {
    width: 48vw;
    left: 4%;
    bottom: 16%;
    opacity: 0.7;
  }

  .hero-container-stack {
    right: 2%;
    top: 22%;
    width: 52vw;
    height: 180px;
  }

  .hero-box {
    width: 132px;
    height: 76px;
    margin-left: -66px;
  }

  .hero-box span:nth-child(2) {
    width: 64px;
    right: -32px;
    transform: rotateY(90deg) translateZ(32px);
  }

  .hero-box span:nth-child(3) {
    height: 64px;
    bottom: -32px;
    transform: rotateX(-90deg) translateZ(32px);
  }

  .hero-crane {
    display: none;
  }
}

@media (max-width: 640px) {
  .hero-scene-stage {
    opacity: 0.55;
  }

  .hero-ship {
    display: none;
  }

  .hero-container-stack {
    right: 50%;
    transform: translateX(50%) rotateX(14deg) rotateY(-24deg) translateZ(20px);
    top: 12%;
  }
}

@media (prefers-reduced-motion: reduce) {
  .hero-scene-orb,
  .hero-ship,
  .hero-ship-wake,
  .hero-container-stack,
  .hero-box-front,
  .hero-crane,
  .hero-crane-cable,
  .hero-crane-hook {
    animation: none !important;
  }

  .hero-scene-stage {
    transition: none;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/HeroScene3D.css"],"names":[],"mappings":"AAAA;EACE,cAAc;EACd,cAAc;EACd,cAAc;EACd,cAAc;EACd,kBAAkB;EAClB,QAAQ;EACR,gBAAgB;EAChB,oBAAoB;EACpB,UAAU;EACV,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR;;;qGAGmG;AACrG;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,UAAU;EACV,WAAW;EACX;uGACqG;EACrG,2CAA2C;EAC3C,+BAA+B;EAC/B,+CAA+C;AACjD;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,aAAa;EACb,mBAAmB;EACnB,4BAA4B;EAC5B;;;kDAGgD;EAChD,oCAAoC;AACtC;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,iBAAiB;EACjB,aAAa;EACb,+CAA+C;AACjD;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,QAAQ;EACR,UAAU;EACV,yFAAyF;AAC3F;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,WAAW;EACX,SAAS;EACT,wFAAwF;EACxF,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,uBAAuB;EACvB,YAAY;EACZ,WAAW;EACX,QAAQ;EACR,0DAA0D;EAC1D,4BAA4B;EAC5B,gDAAgD;EAChD,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,0EAA0E;EAC1E,kDAAkD;EAClD,wCAAwC;EACxC,2CAA2C;AAC7C;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,YAAY;EACZ,UAAU;EACV,YAAY;EACZ,qDAAqD;EACrD,0BAA0B;EAC1B,gDAAgD;AAClD;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,YAAY;EACZ,UAAU;EACV,YAAY;EACZ,qDAAqD;EACrD,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,YAAY;EACZ,UAAU;EACV,YAAY;EACZ,0FAA0F;EAC1F,iBAAiB;EACjB,6CAA6C;AAC/C;;AAEA;EACE,kBAAkB;EAClB,uBAAuB;EACvB,aAAa;EACb,SAAS;EACT,QAAQ;EACR,4BAA4B;EAC5B,0DAA0D;EAC1D,mDAAmD;AACrD;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,YAAY;EACZ,4BAA4B;EAC5B,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,0CAA0C;EAC1C,+CAA+C;AACjD;;AAEA;EACE;;;;;;kEAMgE;EAChE,2BAA2B;AAC7B;;AAEA;EACE,qDAAqD;EACrD,0CAA0C;EAC1C,WAAW;EACX,UAAU;EACV,YAAY;AACd;;AAEA;EACE,oDAAoD;EACpD,2CAA2C;EAC3C,YAAY;EACZ,SAAS;EACT,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,aAAa;EACb,mBAAmB;EACnB,2BAA2B;EAC3B,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,kBAAkB;EAClB,6BAA6B;EAC7B,8CAA8C;EAC9C,oBAAoB;AACtB;;AAEA;EACE,QAAQ;EACR,mDAAmD;EACnD,aAAa;AACf;;AAEA;EACE;;6CAE2C;AAC7C;;AAEA;EACE,SAAS;EACT,kDAAkD;EAClD,aAAa;AACf;;AAEA;EACE;;6CAE2C;AAC7C;;AAEA;EACE,SAAS;EACT,kCAAkC;EAClC,mDAAmD;AACrD;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,UAAU;EACV,QAAQ;EACR,2CAA2C;EAC3C,aAAa;EACb,gDAAgD;AAClD;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,SAAS;EACT,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,qDAAqD;EACrD,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,YAAY;EACZ,WAAW;EACX,oDAAoD;EACpD,kBAAkB;EAClB,6BAA6B;EAC7B,0CAA0C;AAC5C;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,UAAU;EACV,YAAY;EACZ,qCAAqC;EACrC,8CAA8C;AAChD;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,yCAAyC;EACzC,gBAAgB;EAChB,4BAA4B;EAC5B,8CAA8C;AAChD;;AAEA;EACE;;IAEE,+BAA+B;EACjC;EACA;IACE,yCAAyC;EAC3C;AACF;;AAEA;EACE;;IAEE,wEAAwE;EAC1E;EACA;IACE,4EAA4E;EAC9E;AACF;;AAEA;EACE;;IAEE,aAAa;IACb,oBAAoB;EACtB;EACA;IACE,YAAY;IACZ,uBAAuB;EACzB;AACF;;AAEA;EACE;;IAEE,wEAAwE;EAC1E;EACA;IACE,4EAA4E;EAC9E;AACF;;AAEA;EACE;;IAEE,oDAAoD;EACtD;EACA;IACE,yDAAyD;EAC3D;AACF;;AAEA;EACE;;IAEE,2DAA2D;EAC7D;EACA;IACE,0DAA0D;EAC5D;AACF;;AAEA;EACE;;IAEE,wBAAwB;EAC1B;EACA;IACE,2BAA2B;EAC7B;AACF;;AAEA;EACE;IACE,WAAW;IACX,QAAQ;IACR,WAAW;IACX,YAAY;EACd;;EAEA;IACE,SAAS;IACT,QAAQ;IACR,WAAW;IACX,aAAa;EACf;;EAEA;IACE,YAAY;IACZ,YAAY;IACZ,kBAAkB;EACpB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,0CAA0C;EAC5C;;EAEA;IACE,YAAY;IACZ,aAAa;IACb,2CAA2C;EAC7C;;EAEA;IACE,aAAa;EACf;AACF;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,UAAU;IACV,0EAA0E;IAC1E,QAAQ;EACV;AACF;;AAEA;EACE;;;;;;;;IAQE,0BAA0B;EAC5B;;EAEA;IACE,gBAAgB;EAClB;AACF","sourcesContent":[".hero-scene-3d {\n  --tilt-x: 0deg;\n  --tilt-y: 0deg;\n  --shift-x: 0px;\n  --shift-y: 0px;\n  position: absolute;\n  inset: 0;\n  overflow: hidden;\n  pointer-events: none;\n  z-index: 0;\n  perspective: 1200px;\n}\n\n.hero-scene-sky {\n  position: absolute;\n  inset: 0;\n  background:\n    radial-gradient(ellipse 70% 55% at 75% 20%, rgba(212, 175, 55, 0.22), transparent 60%),\n    radial-gradient(ellipse 55% 50% at 15% 75%, rgba(13, 148, 136, 0.18), transparent 55%),\n    linear-gradient(160deg, rgba(10, 37, 64, 0.15) 0%, rgba(37, 99, 235, 0.08) 55%, transparent 100%);\n}\n\n.hero-scene-horizon {\n  position: absolute;\n  left: -10%;\n  right: -10%;\n  bottom: 8%;\n  height: 42%;\n  background:\n    linear-gradient(180deg, transparent 0%, rgba(255, 255, 255, 0.06) 35%, rgba(10, 37, 64, 0.35) 100%);\n  transform: rotateX(62deg) translateZ(-80px);\n  transform-origin: center bottom;\n  border-top: 1px solid rgba(255, 255, 255, 0.12);\n}\n\n.hero-scene-stage {\n  position: absolute;\n  inset: 0;\n  display: grid;\n  place-items: center;\n  transform-style: preserve-3d;\n  transform:\n    rotateX(var(--tilt-x))\n    rotateY(var(--tilt-y))\n    translate3d(var(--shift-x), var(--shift-y), 0);\n  transition: transform 0.35s ease-out;\n}\n\n.hero-scene-orb {\n  position: absolute;\n  border-radius: 50%;\n  filter: blur(2px);\n  opacity: 0.55;\n  animation: heroOrbFloat 9s ease-in-out infinite;\n}\n\n.hero-scene-orb-a {\n  width: 180px;\n  height: 180px;\n  top: 14%;\n  right: 12%;\n  background: radial-gradient(circle at 35% 35%, rgba(212, 175, 55, 0.45), transparent 70%);\n}\n\n.hero-scene-orb-b {\n  width: 140px;\n  height: 140px;\n  bottom: 18%;\n  left: 10%;\n  background: radial-gradient(circle at 40% 40%, rgba(49, 130, 206, 0.4), transparent 70%);\n  animation-delay: -3s;\n}\n\n.hero-ship {\n  position: absolute;\n  width: min(42vw, 340px);\n  height: 78px;\n  bottom: 22%;\n  left: 8%;\n  transform: translateZ(-40px) rotateY(-18deg) rotateX(8deg);\n  transform-style: preserve-3d;\n  animation: heroShipBob 5.5s ease-in-out infinite;\n  opacity: 0.9;\n}\n\n.hero-ship-hull {\n  position: absolute;\n  inset: 28px 0 0;\n  background: linear-gradient(180deg, #dbe7f5 0%, #8fa7c4 45%, #3d5a80 100%);\n  clip-path: polygon(4% 0, 96% 0, 100% 100%, 0 100%);\n  border-radius: 0 0 40% 40% / 0 0 60% 60%;\n  box-shadow: 0 18px 30px rgba(0, 0, 0, 0.28);\n}\n\n.hero-ship-bridge {\n  position: absolute;\n  width: 22%;\n  height: 34px;\n  right: 12%;\n  bottom: 48px;\n  background: linear-gradient(180deg, #f8fafc, #94a3b8);\n  border-radius: 4px 4px 0 0;\n  box-shadow: inset 0 -8px 0 rgba(10, 37, 64, 0.2);\n}\n\n.hero-ship-stack {\n  position: absolute;\n  width: 8%;\n  height: 28px;\n  right: 18%;\n  bottom: 78px;\n  background: linear-gradient(180deg, #d4af37, #8b6914);\n  border-radius: 3px 3px 0 0;\n}\n\n.hero-ship-wake {\n  position: absolute;\n  left: -18%;\n  bottom: -6px;\n  width: 40%;\n  height: 16px;\n  background: radial-gradient(ellipse at center, rgba(255, 255, 255, 0.45), transparent 70%);\n  filter: blur(2px);\n  animation: heroWake 2.8s ease-in-out infinite;\n}\n\n.hero-container-stack {\n  position: absolute;\n  width: min(46vw, 360px);\n  height: 220px;\n  right: 8%;\n  top: 18%;\n  transform-style: preserve-3d;\n  transform: rotateX(12deg) rotateY(-28deg) translateZ(40px);\n  animation: heroStackFloat 6.5s ease-in-out infinite;\n}\n\n.hero-box {\n  position: absolute;\n  width: 170px;\n  height: 98px;\n  transform-style: preserve-3d;\n  left: 50%;\n  margin-left: -85px;\n}\n\n.hero-box span {\n  position: absolute;\n  inset: 0;\n  border: 1px solid rgba(255, 255, 255, 0.2);\n  box-shadow: inset 0 0 0 1px rgba(0, 0, 0, 0.08);\n}\n\n.hero-box span:nth-child(1) {\n  background:\n    repeating-linear-gradient(\n      90deg,\n      rgba(255, 255, 255, 0.08) 0 8px,\n      transparent 8px 18px\n    ),\n    linear-gradient(145deg, #d4af37 0%, #b8945f 55%, #8b6914 100%);\n  transform: translateZ(42px);\n}\n\n.hero-box span:nth-child(2) {\n  background: linear-gradient(180deg, #2c5282, #1a365d);\n  transform: rotateY(90deg) translateZ(42px);\n  width: 84px;\n  left: auto;\n  right: -42px;\n}\n\n.hero-box span:nth-child(3) {\n  background: linear-gradient(90deg, #1e3a5f, #0f2744);\n  transform: rotateX(-90deg) translateZ(42px);\n  height: 84px;\n  top: auto;\n  bottom: -42px;\n}\n\n.hero-box em {\n  position: absolute;\n  inset: 0;\n  display: grid;\n  place-items: center;\n  transform: translateZ(43px);\n  font-style: normal;\n  font-weight: 800;\n  letter-spacing: 0.14em;\n  font-size: 0.78rem;\n  color: rgba(10, 37, 64, 0.85);\n  text-shadow: 0 1px 0 rgba(255, 255, 255, 0.25);\n  pointer-events: none;\n}\n\n.hero-box-back {\n  top: 8px;\n  transform: translate3d(-36px, 0, -70px) scale(0.92);\n  opacity: 0.72;\n}\n\n.hero-box-back span:nth-child(1) {\n  background:\n    repeating-linear-gradient(90deg, rgba(255, 255, 255, 0.07) 0 8px, transparent 8px 18px),\n    linear-gradient(145deg, #3182ce, #1a365d);\n}\n\n.hero-box-mid {\n  top: 46px;\n  transform: translate3d(18px, 0, -20px) scale(0.96);\n  opacity: 0.88;\n}\n\n.hero-box-mid span:nth-child(1) {\n  background:\n    repeating-linear-gradient(90deg, rgba(255, 255, 255, 0.08) 0 8px, transparent 8px 18px),\n    linear-gradient(145deg, #0d9488, #115e59);\n}\n\n.hero-box-front {\n  top: 88px;\n  transform: translate3d(0, 0, 30px);\n  animation: heroFrontPulse 4.8s ease-in-out infinite;\n}\n\n.hero-crane {\n  position: absolute;\n  width: 160px;\n  height: 220px;\n  right: 42%;\n  top: 10%;\n  transform: translateZ(-10px) rotateY(12deg);\n  opacity: 0.75;\n  animation: heroCraneSway 7s ease-in-out infinite;\n}\n\n.hero-crane-mast {\n  position: absolute;\n  left: 50%;\n  bottom: 0;\n  width: 10px;\n  height: 100%;\n  margin-left: -5px;\n  background: linear-gradient(180deg, #f8fafc, #64748b);\n  border-radius: 4px;\n}\n\n.hero-crane-arm {\n  position: absolute;\n  top: 18%;\n  left: 18%;\n  width: 120px;\n  height: 8px;\n  background: linear-gradient(90deg, #d4af37, #f1e4b3);\n  border-radius: 4px;\n  transform-origin: left center;\n  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.25);\n}\n\n.hero-crane-cable {\n  position: absolute;\n  top: 22%;\n  left: 78%;\n  width: 2px;\n  height: 70px;\n  background: rgba(255, 255, 255, 0.55);\n  animation: heroCable 3.6s ease-in-out infinite;\n}\n\n.hero-crane-hook {\n  position: absolute;\n  top: calc(22% + 70px);\n  left: calc(78% - 8px);\n  width: 18px;\n  height: 14px;\n  border: 2px solid rgba(212, 175, 55, 0.9);\n  border-top: none;\n  border-radius: 0 0 10px 10px;\n  animation: heroCable 3.6s ease-in-out infinite;\n}\n\n@keyframes heroOrbFloat {\n  0%,\n  100% {\n    transform: translate3d(0, 0, 0);\n  }\n  50% {\n    transform: translate3d(12px, -18px, 20px);\n  }\n}\n\n@keyframes heroShipBob {\n  0%,\n  100% {\n    transform: translateZ(-40px) rotateY(-18deg) rotateX(8deg) translateY(0);\n  }\n  50% {\n    transform: translateZ(-40px) rotateY(-18deg) rotateX(8deg) translateY(-10px);\n  }\n}\n\n@keyframes heroWake {\n  0%,\n  100% {\n    opacity: 0.35;\n    transform: scaleX(1);\n  }\n  50% {\n    opacity: 0.7;\n    transform: scaleX(1.15);\n  }\n}\n\n@keyframes heroStackFloat {\n  0%,\n  100% {\n    transform: rotateX(12deg) rotateY(-28deg) translateZ(40px) translateY(0);\n  }\n  50% {\n    transform: rotateX(12deg) rotateY(-28deg) translateZ(40px) translateY(-14px);\n  }\n}\n\n@keyframes heroFrontPulse {\n  0%,\n  100% {\n    filter: drop-shadow(0 18px 24px rgba(0, 0, 0, 0.28));\n  }\n  50% {\n    filter: drop-shadow(0 26px 34px rgba(212, 175, 55, 0.28));\n  }\n}\n\n@keyframes heroCraneSway {\n  0%,\n  100% {\n    transform: translateZ(-10px) rotateY(12deg) rotate(-1.5deg);\n  }\n  50% {\n    transform: translateZ(-10px) rotateY(12deg) rotate(1.5deg);\n  }\n}\n\n@keyframes heroCable {\n  0%,\n  100% {\n    transform: translateY(0);\n  }\n  50% {\n    transform: translateY(12px);\n  }\n}\n\n@media (max-width: 900px) {\n  .hero-ship {\n    width: 48vw;\n    left: 4%;\n    bottom: 16%;\n    opacity: 0.7;\n  }\n\n  .hero-container-stack {\n    right: 2%;\n    top: 22%;\n    width: 52vw;\n    height: 180px;\n  }\n\n  .hero-box {\n    width: 132px;\n    height: 76px;\n    margin-left: -66px;\n  }\n\n  .hero-box span:nth-child(2) {\n    width: 64px;\n    right: -32px;\n    transform: rotateY(90deg) translateZ(32px);\n  }\n\n  .hero-box span:nth-child(3) {\n    height: 64px;\n    bottom: -32px;\n    transform: rotateX(-90deg) translateZ(32px);\n  }\n\n  .hero-crane {\n    display: none;\n  }\n}\n\n@media (max-width: 640px) {\n  .hero-scene-stage {\n    opacity: 0.55;\n  }\n\n  .hero-ship {\n    display: none;\n  }\n\n  .hero-container-stack {\n    right: 50%;\n    transform: translateX(50%) rotateX(14deg) rotateY(-24deg) translateZ(20px);\n    top: 12%;\n  }\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .hero-scene-orb,\n  .hero-ship,\n  .hero-ship-wake,\n  .hero-container-stack,\n  .hero-box-front,\n  .hero-crane,\n  .hero-crane-cable,\n  .hero-crane-hook {\n    animation: none !important;\n  }\n\n  .hero-scene-stage {\n    transition: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
